import "./file_type_label.scss"

